import {
  AdvertisementCarousel,
  AppFooter,
  BookingConfirmation,
  BookingPaymentStatusCard,
  FoodBooking,
  ForgotPasswordFormCard,
  HomeBannerCarousel,
  LoginFormCard,
  MovieDetailCard,
  MovieList,
  NextReleaseUpcoming,
  NowShowing,
  NowShowingUpcoming,
  NowShowingWithGalleryAndList,
  RegisterFormCard,
  ResetPasswordFormCard,
  SeatBooking,
  ShowListContainer,
} from "@components/index";

import { AdvertismentCard } from "@/components/AdvertisemntCard";
import BreadCrumbsSection from "@/components/BreadCrumbsSection";
import {
  BigForgotPasswordFormCard,
  BigLoginFormCard,
  BigRegisterFormCard,
} from "@/components/Cards/BigFormCard";
import FoodCheckout from "@/components/Food/FoodCheckout";
import HeaderBg from "@/components/HeaderBg";
import QuickBookingForm from "@/components/QuickBookingForm";
import BookingFormWithDetail from "@/components/QuickBookingForm/bookingFormWithDetail";
import MovieScheduleGrid from "@/components/MovieScheduleGrid";
import UserProfileINI from "@/components/UserProfile/ProfileINI";
import SocialVerifyPage from "@/pages/auth/social/[social-auth-provider]/verify";
import ContactComponent1 from "@/components/contact/ContactComponent1";
import WhatsAppContactCard from "@/components/contact/WhatsAppContactCard";
import MovieBannerComponent1 from "@/components/MovieDetail/MovieBannerComponent1";
import MovieDetailComponent1 from "@/components/MovieDetail/MovieDetailComponent1";
import ShowNoteCardComponent1 from "@/components/ShowList/ShowNoteCardComponent1";
import { default as Navbar } from "@components/Navbar";
import { default as RenderHtml } from "@components/RenderHtml";
import { default as UserProfile } from "@components/UserProfile/Profile";
import { default as ProfileEdit } from "@components/UserProfile/ProfileEdit";

export const componentByType = Object.freeze({
  header_bg: HeaderBg,
  navbar: Navbar,
  banner_carousel: HomeBannerCarousel,
  advertisement_slider: AdvertisementCarousel,
  advertisement_detail: AdvertismentCard,
  now_showing: NowShowing,
  now_showing_upcoming: NowShowingUpcoming,
  next_release_upcoming_tab: NextReleaseUpcoming,
  movie_list: MovieList,
  big_now_showing: NowShowingWithGalleryAndList,
  movie_detail_card: MovieDetailCard,
  show_list: ShowListContainer,
  footer: AppFooter,
  login_form_card: LoginFormCard,
  big_login_form_card: BigLoginFormCard,
  register_form_card: RegisterFormCard,
  big_register_form_card: BigRegisterFormCard,
  forgot_password_card: ForgotPasswordFormCard,
  big_forgot_password_form_card: BigForgotPasswordFormCard,
  reset_password_card: ResetPasswordFormCard,
  social_auth: SocialVerifyPage,
  quick_booking_form: QuickBookingForm,
  seat_booking: SeatBooking,
  food_booking: FoodBooking,
  booking_confirmation_card: BookingConfirmation,
  booking_payment_status_card: BookingPaymentStatusCard,

  html_render_component: RenderHtml,
  about_render_component: RenderHtml,
  contact_render_component: RenderHtml,
  contact_component_1: ContactComponent1,
  whatsapp_contact_card: WhatsAppContactCard,
  show_note_card_component_1: ShowNoteCardComponent1,
  movie_banner_component_1: MovieBannerComponent1,
  movie_detail_component_1: MovieDetailComponent1,
  faq_render_component: RenderHtml,
  privacy_policy_render_component: RenderHtml,
  terms_and_conditions_render_component: RenderHtml,
  ticket_rate_render_component: RenderHtml,

  profile_edit: ProfileEdit,
  user_profile: UserProfile,
  user_profile_ini: UserProfileINI,
  booking_form_with_detail: BookingFormWithDetail,
  movie_schedule_grid: MovieScheduleGrid,
  food_checkout: FoodCheckout,
  bread_crumbs_section: BreadCrumbsSection,
});
